import { render } from "./BusinessLogo.vue?vue&type=template&id=3d99ac0f&ts=true"
import script from "./BusinessLogo.vue?vue&type=script&lang=ts"
export * from "./BusinessLogo.vue?vue&type=script&lang=ts"

import "./BusinessLogo.vue?vue&type=style&index=0&id=3d99ac0f&lang=scss"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__